// extracted by mini-css-extract-plugin
export var modalFooter = "_mm-0";